import { Controller } from "@hotwired/stimulus";

/**
 * Le format d'un template se DÉCIDE (sélecteur du header de l'éditeur) : PATCH du document
 * (vérité serveur) puis retaille EN PLACE — l'orchestrateur écoute l'événement, les calques
 * ne bougent pas, seul le cadre change. Un select nu, pas de <form> : l'éditeur vit déjà
 * dans un form, l'imbrication casserait le DOM.
 *
 * Naming: "document-format" in HTML.
 */
export default class extends Controller {
  static values = { url: String };

  async apply() {
    await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
      },
      body: new URLSearchParams({ dimensions: this.element.value }),
    });
    const [width, height] = this.element.value.split("x").map(Number);
    window.dispatchEvent(new CustomEvent("document:resize", { detail: { width, height } }));
  }
}
